module.exports = "<menu>\r\n  <li [ngClass]=\"{'active' : router.url === '/MyRecordings'}\">\r\n    <button routerLink=\"/MyRecordings\" mat-button class=\"recordings-icon icons-sizing\"></button>\r\n  </li>\r\n  <li [ngClass]=\"{'active' : router.url === '/Info'}\">\r\n    <a href=\"https://supercallrecorderapp.com/\" target=\"_blank\"><button mat-button class=\"info-icon icons-sizing\"></button></a>\r\n  </li>\r\n</menu>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/sidebar/sidebar.component.html
// module id = ./src/app/header/sidebar/sidebar.component.html
// module chunks = main